import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import { getModule} from 'vuex-module-decorators';
import axios, {AxiosPromise}  from 'axios';
import Nomenclatures from "@/module/store/nomenclatures"
import  {displayLink}  from '@/module/utils';
import User from "@/module/store/user";
import {CONFIG_ENV} from '@/config';
import {I_Gift} from "@/types/iGift";

import EditGiftForList from "@/components/EditGiftForList/EditGiftForList";

interface I_AjaxResponse_GetListGifts{
    status:number,
    statusText:string,
    data: {
        status:string,
        message:string,
        list_gifts:Array<I_Gift>
    }
}

interface I_AjaxResponse_DeleteGiftFromList{
    status:number,
    statusText:string,
    data: {
        status:string,
        message:string,
    }
}

@Component({components:{EditGiftForList}})
export default class GiftsList extends Vue {
    @Prop() listid!: number;
    @Prop() editable!:boolean;
    @Prop() list_name!:string;
    myBoolTrue:boolean=true;
    myBoolFalse:boolean=false;
    xsm:string='xsm';
    ajaxIsLoadinGifts:boolean=false;
    dialogAddChildToList:boolean=false;
    currentChildComponent:string='';
    childid_for_edit:number=0;

    listGifts:Array<I_Gift>=[];

    $refs:any;
    private userStore=getModule(User)
    private nomenclaturesStore=getModule(Nomenclatures);

    constructor(){
        super();
    }

    displayLink50Chr(pstr:string):string{
        return displayLink(pstr);
    }

    shareProduct(pstr:string){
        this.$q.notify({
            color: 'red-5',
            textColor: 'white',
            position:'top-right',
            icon: 'fas fa-exclamation-triangle',
            message: 'Ne pare rau, dar aceasta functionalitate nu a fost implementata!'
        });
    }

    async deleteGiftFromList(pgift:I_Gift){
        const vueInst=this;
        let res = await <Promise<I_AjaxResponse_DeleteGiftFromList>> axios.post(`${CONFIG_ENV.URL_GIFTS.delete_gift_from_list}/${pgift.listid}/${pgift.giftid}`);
        return res;
    }

    closeChildFormAndReloadGiftsFromDB(){
        const vueInst=this;
        vueInst.dialogAddChildToList=false;
        vueInst.currentChildComponent='';
        vueInst.getListGiftsFromDB(vueInst.listid);
    }

    async getListGiftsFromDB(plistid:number){
      console.log('getListGiftsFromDB for plistid=%o',plistid)
        const vueInst=this;
        vueInst.ajaxIsLoadinGifts=true;
        vueInst.listGifts=[];
        let resFromAjax = await <Promise<I_AjaxResponse_GetListGifts>> axios.get(`${CONFIG_ENV.URL_GIFTS.get_list_gifts}/${plistid}`);
        resFromAjax.data.list_gifts.forEach((pgift:I_Gift)=>{
            vueInst.listGifts.push({
                listid:pgift.listid,
                giftid:pgift.giftid,
                userid:pgift.userid,
                gift_name:pgift.gift_name,
                gift_quantity:pgift.gift_quantity,
                gift_description:pgift.gift_description,
                gift_price:pgift.gift_price,
                gift_currency:pgift.gift_currency,
                gift_url_host:'https://www.emag.ro/laptop-huawei-matebook-d-cu-procesor-intelr-coretm-i5-8250u-pana-la-3-40-ghz-kaby-lake-r-15-6-8gb-256gb-ssd-intel-uhd-graphics-620-microsoft-windows-10-gray-53010cem/pd/DPHYQCBBM/?ref=others_also_viewed_1_3&provider=rec-go&recid=rec_golang_43_466fec6ab4074a558fa43f2846b16932_1565790470&scenario_ID=43',//pgift.gift_url_host,
                gift_url_image:pgift.gift_url_host,
                gift_imageid:pgift.gift_imageid,
                status:pgift.status,
                img_as_str:pgift.img_as_str
            });
        });
        vueInst.ajaxIsLoadinGifts=false;
    }

    formatTextLink(ptext:string):string{
        ptext=ptext.replace("http://", "");
        ptext=ptext.replace("https://", "");
        if (ptext.length>30) {
            return ptext.substring(0, 20) + "..." + ptext.substr(ptext.length - 5);
        }
        else {return ptext;}
    }

    tryToOpenGiftForUpdate(gift:I_Gift){
        this.childid_for_edit=gift.giftid;
        this.dialogAddChildToList=true;
        this.currentChildComponent='EditGiftForList';
    }

    openFormNewGift(){
        this.childid_for_edit=0;
        this.dialogAddChildToList=true;
        this.currentChildComponent='EditGiftForList';
    }

    tryToDeleteGiftFromList(pgift:I_Gift){
        var vueInst = this;
        this.$q.dialog({
            title: 'Stergere cadou din lista',
            message: 'Continuati?',
            cancel: true,
            persistent: true
        }).onOk(() => {
            vueInst.deleteGiftFromList(pgift).then((response:I_AjaxResponse_DeleteGiftFromList)=>{
                if(response.data.status=="success"){
                    vueInst.listGifts.forEach((gift:I_Gift,index:number)=>{
                        if(gift.giftid==pgift.giftid){
                            vueInst.listGifts.splice(index,1);
                        }
                    })

                }
            })
        });
    }

    @Watch("listid",{ deep: true})
    listidChanged(newValue: any, oldValue: any) {
        //console.log('onstatementPropChanged with newValue=%o and oldValue=%o',JSON.stringify(newValue),JSON.stringify(oldValue))
        const vueInst=this;
        if(typeof newValue !== 'undefined' && typeof oldValue !== 'undefined'){
            if(vueInst.listid && 1*vueInst.listid>0) {
                vueInst.getListGiftsFromDB(vueInst.listid);
            }
        }
    }

    activated(){
        const vueInst=this;
        vueInst.listGifts=[];
        if(vueInst.listid && 1*vueInst.listid>0){
            vueInst.getListGiftsFromDB(vueInst.listid);
        }
        else{
            vueInst.$q.notify({
                color: 'red-5',
                textColor: 'white',
                position:'top-right',
                icon: 'fas fa-exclamation-triangle',
                message: 'Lipseste identificatorul listei! Apasati F5 si incercati din nou!'
            });
        }
    }

    created() {
        var vueInst = this;
        //@ts-ignore
        vueInst.$eventHub.$on('infofromchildCommand', (params: any) => {
            vueInst.closeChildFormAndReloadGiftsFromDB();
        });
    }

    beforeDestroy() {
        //@ts-ignore
        this.$eventHub.$off('infofromchildCommand');
    }
}
